<div *ngFor="let item of section.items" class="d-flex justify-content-center mt-2">
  <video controls autoplay [id]="item.name">
    <source [src]="item?.photo" type="video/mp4">
    Tu navegador no soporta el elemento de video.
  </video>
</div>